
import React from 'react';
import { usePersonaContext } from '@/contexts/PersonaContext';
import { AppNavbar } from '@/components/layout/AppNavbar';
import { BrandDashboard } from '@/components/brand/BrandDashboard';

const BrandUser = () => {
  const { currentPersona } = usePersonaContext();
  
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <AppNavbar />
      
      <main className="flex-1 container py-12">
        <BrandDashboard />
      </main>
    </div>
  );
};

export default BrandUser;
